import React from 'react';
import NetlifyForm from '../../forms/netlifyForm';
import ModuleWrapper from '../moduleWrapper';
import SimplePortableText from '../../sanity/simplePortableText';

const EmbeddedForm = ({ form, text, config }) => {
  return (
    <ModuleWrapper {...config} className='pt-20 lg:pt-40'>
      <div className='flex flex-col lg:flex-row py-10 px-10 xl:px-40 justify-center gap-20'>
        <SimplePortableText
          text={text}
          className='flex w-full lg:w-[40vw] md:py-3'
        />
        <NetlifyForm {...form} />
      </div>
    </ModuleWrapper>
  );
};

export default EmbeddedForm;
